import { render } from "./AssetTokenInfo.vue?vue&type=template&id=0f812e3c&scoped=true"
import script from "./AssetTokenInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetTokenInfo.vue?vue&type=script&setup=true&lang=js"

import "./AssetTokenInfo.vue?vue&type=style&index=0&id=0f812e3c&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f812e3c"],['__file',"resources/js/components/AssetTokenInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f812e3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f812e3c', __exports__)) {
    api.reload('0f812e3c', __exports__)
  }
  
  module.hot.accept("./AssetTokenInfo.vue?vue&type=template&id=0f812e3c&scoped=true", () => {
    api.rerender('0f812e3c', render)
  })

}


export default __exports__